export default {
    NON_REFUNDABLE: 0,
    CONDITIONS: 1,
    REFUNDABLE: 2,
};



// WEBPACK FOOTER //
// ./src/app/modules/hotels/config/refundable-type.js